import { Link, useHistory } from "react-router-dom";
import { AnalyticsItemList } from "../../tools/analytics/analytics.types";
import { gaEventSelectItemPlaylist } from "../../tools/analytics/domains/playlist.analytics";
import { usePageLinks } from "../../domains/app/hooks/usePageLinks";
import PlaylistCard from "../cards/PlaylistCard";
import Loader from "../Loader";
import AppCarousel from "./AppCarousel";
import { useTranslation } from "react-i18next";
import type { ApiPlaylistModel } from "../../domains/playlist/hooks/useGetRecommendedPlaylistsQuery";

interface PlaylistCarouselProps {
  title: string;
  linkTo: string;
  playlists: ApiPlaylistModel[];
  backgroundColor?: string;
}

export default function PlaylistCarousel({
  title,
  linkTo,
  playlists,
  backgroundColor = "#FFF",
}: PlaylistCarouselProps) {
  const { t } = useTranslation();
  const history = useHistory();
  const { publicPlaylistLink } = usePageLinks(null);
  return (
    <div
      className="py-[16px] bg-secondary-soft-yellow-2"
      style={{ background: backgroundColor }}
    >
      <div className="pt-[24px] px-[21px] pb-[8px] flex items-center justify-between">
        <span className="font-bold text-[16px] text-secondary-bluegrey-7 leading-[120%]">
          {title}
        </span>
        <Link
          to={linkTo}
          className="font-bold text-[12px] text-secondary-raspberry-1 leading-[14px] underline"
        >
          <span>{t("See all")}</span>
        </Link>
      </div>

      {playlists.length > 0 ? (
        <AppCarousel desktopGrid slideGutter="sm">
          {playlists.slice(0, 5).map((playlist) => (
            <PlaylistCard
              key={playlist.id}
              playlist={playlist}
              variant="dark"
              onClick={() => {
                gaEventSelectItemPlaylist({
                  playlist,
                  listName: AnalyticsItemList.DISCOVERY_PLAYLISTS,
                });
                history.push({
                  pathname: publicPlaylistLink(playlist),
                  state: { playlist },
                });
              }}
            />
          ))}
        </AppCarousel>
      ) : (
        <Loader />
      )}
    </div>
  );
}
